import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";

import JobseekerLogin from "./pages/jobseeker/Login";
import JobseekerOtpVerify from "./pages/jobseeker/VerifyOtp";
import EmployerLogin from "./pages/employer/Login";
import EmployerOtpVerify from "./pages/employer/VerifyOtp";

import JobseekerHome from "./pages/jobseeker/Home";
import JobseekerJobList from "./pages/jobseeker/JobList";
import JobseekerCategory from "./pages/jobseeker/Category";
import JobseekerJobCategory from "./pages/jobseeker/JobCategory";
import JobseekerCompanyJobs from "./pages/jobseeker/CompanyJobs";
import JobseekerJobDetails from "./pages/jobseeker/JobDetails";
import JobseekerAbout from "./pages/jobseeker/About";
import JobseekerContact from "./pages/jobseeker/Contact";
import JobseekerDataProcessing from "./pages/jobseeker/DataProcessing";
import JobseekerUserService from "./pages/jobseeker/UserService";
import JobseekerPaymentRefund from "./pages/jobseeker/PaymentRefund";
import JobseekerTermCondition from "./pages/jobseeker/TermCondition";
import JobseekerAppTermCondition from "./pages/jobseeker/AppTermCondition";
import JobseekerPrivacyPolicy from "./pages/jobseeker/PrivacyPolicy";
import JobseekerCookiePolicy from "./pages/jobseeker/CookiePolicy";
import JobseekerDashboard from "./pages/jobseeker/Dashboard";
import JobseekerProfile from "./pages/jobseeker/dashboard/Profile";
import JobseekerEditProfile from "./pages/jobseeker/EditProfile";
import ResumePrint from "./pages/jobseeker/dashboard/ResumePrint";
import JobseekerBank from "./pages/jobseeker/dashboard/Bank";
import JobseekerJobsApplied from "./pages/jobseeker/dashboard/JobsApplied";
import JobseekerSavedJobs from "./pages/jobseeker/dashboard/SavedJobs";
import JobseekerManageTask from "./pages/jobseeker/dashboard/ManageTask";
import JobseekerTaskList from "./pages/jobseeker/dashboard/TaskList";
import JobseekePaymentHistory from "./pages/jobseeker/dashboard/PaymentHistory";

import EmployerHome from "./pages/employer/Home";
import EmployerCandidate from "./pages/employer/Candidate";
import EmployerCandidateIndustry from "./pages/employer/IndustryCandidateList";
import EmployerCandidateDetails from "./pages/employer/CandidateDetails";
import EmployerDashboard from "./pages/employer/Dashboard";
import EmployerProfile from "./pages/employer/dashboard/Profile";
import EmployerJobList from "./pages/employer/dashboard/JobList";
import EmployerPostJob from "./pages/employer/dashboard/PostJob";
import EmployerEditJob from "./pages/employer/dashboard/EditJob";
import EmployerJobApplication from "./pages/employer/dashboard/JobApplication";
import EmployerApplicationList from "./pages/employer/dashboard/ApplicationList";
import EmployerConnectedCandidate from "./pages/employer/dashboard/ConnectedCandidate";
import EmployerMakePayment from "./pages/employer/dashboard/MakePayment";
import EmployerPaymentHistory from "./pages/employer/dashboard/PaymentHistory";
import EmployerTaskList from "./pages/employer/dashboard/TaskList";


function App() {
  return (
    <Router>
      <Routes>
        {/* Authentication */}
        <Route path="/jobseeker/login" element={<JobseekerLogin />} />
        <Route path="/jobseeker/verify-otp" element={<JobseekerOtpVerify />} />
        <Route path="/employer/login" element={<EmployerLogin />} />
        <Route path="/employer/verify-otp" element={<EmployerOtpVerify />} />

        {/* Public Pages */}
        <Route path="/" element={<JobseekerHome />} />
        <Route path="/about" element={<JobseekerAbout />} />
        <Route path="/contact-us" element={<JobseekerContact />} />
        <Route path="/job-list" element={<JobseekerJobList />} />
        <Route path="/data-processing-agreement" element={<JobseekerDataProcessing />} />
        <Route path="/user-service-agreement" element={<JobseekerUserService />} />
        <Route path="/payment-refund" element={<JobseekerPaymentRefund />} />
        <Route path="/terms-and-condition" element={<JobseekerTermCondition />} />
        <Route path="/privacy-policy" element={<JobseekerPrivacyPolicy />} />
        <Route path="/cookie-policy" element={<JobseekerCookiePolicy />} />
        <Route path="/app-terms-and-conditons" element={<JobseekerAppTermCondition />} />

        <Route path="/job-category/:categoryId" element={<JobseekerJobCategory />} />
        <Route path="/job-category" element={<JobseekerCategory />} />
        <Route path="/job-details/:jobId" element={<JobseekerJobDetails />} />
        <Route path="/company-job-posts/:companyId" element={<JobseekerCompanyJobs />} />
        
        
        {/* Employer Home (public, optional) */}
        <Route path="/employer/home" element={<EmployerHome />} />
        <Route path="/employer/candidate-list" element={<EmployerCandidate />} />
        <Route path="/employer/candidate-list-industry/:industryId" element={<EmployerCandidateIndustry />} />
        <Route path="/employer/candidate/:candidateId" element={<EmployerCandidateDetails />} />
        {/* <Route path="/employer/candidate/:candidateId" element={<EmployerCandidateDetails />} /> */}

        {/* Jobseeker (protected) */}
        <Route
          path="/jobseeker/dashboard"
          element={
            <ProtectedRoute allowedRoles={["job_seeker"]}>
              <JobseekerDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/jobseeker/profile"
          element={
            <ProtectedRoute allowedRoles={["job_seeker"]}>
              <JobseekerProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/jobseeker/edit-profile"
          element={
            <ProtectedRoute allowedRoles={["job_seeker"]}>
              <JobseekerEditProfile />
            </ProtectedRoute>
          }
        />
        <Route path="/jobseeker/resume/print" element={<ResumePrint />} />
        <Route
          path="/jobseeker/bank"
          element={
            <ProtectedRoute allowedRoles={["job_seeker"]}>
              <JobseekerBank />
            </ProtectedRoute>
          }
        />
        <Route
          path="/jobseeker/jobs-applied"
          element={
            <ProtectedRoute allowedRoles={["job_seeker"]}>
              <JobseekerJobsApplied />
            </ProtectedRoute>
          }
        />
        <Route
          path="/jobseeker/saved-jobs"
          element={
            <ProtectedRoute allowedRoles={["job_seeker"]}>
              <JobseekerSavedJobs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/jobseeker/manage-task"
          element={
            <ProtectedRoute allowedRoles={["job_seeker"]}>
              <JobseekerManageTask />
            </ProtectedRoute>
          }
        />
        <Route
          path="/jobseeker/payment-history"
          element={
            <ProtectedRoute allowedRoles={["job_seeker"]}>
              <JobseekePaymentHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/jobseeker/task-list/:applicationId"
          element={
            <ProtectedRoute allowedRoles={["job_seeker"]}>
              <JobseekerTaskList />
            </ProtectedRoute>
          }
        />





        {/* Employer (protected) */}
        <Route
          path="/employer/dashboard"
          element={
            <ProtectedRoute allowedRoles={["employer"]}>
              <EmployerDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/profile"
          element={
            <ProtectedRoute allowedRoles={["employer"]}>
              <EmployerProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/job-list"
          element={
            <ProtectedRoute allowedRoles={["employer"]}>
              <EmployerJobList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/post-job"
          element={
            <ProtectedRoute allowedRoles={["employer"]}>
              <EmployerPostJob />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/edit-job/:jobId"
          element={
            <ProtectedRoute allowedRoles={["employer"]}>
              <EmployerEditJob />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/job-applications"
          element={
            <ProtectedRoute allowedRoles={["employer"]}>
              <EmployerJobApplication />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/application-list/:jobId"
          element={
            <ProtectedRoute allowedRoles={["employer"]}>
              <EmployerApplicationList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/connected-candidates"
          element={
            <ProtectedRoute allowedRoles={["employer"]}>
              <EmployerConnectedCandidate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/task-list/:applicationId"
          element={
            <ProtectedRoute allowedRoles={["employer"]}>
              <EmployerTaskList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/make-payment"
          element={
            <ProtectedRoute allowedRoles={["employer"]}>
              <EmployerMakePayment />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employer/payment-history"
          element={
            <ProtectedRoute allowedRoles={["employer"]}>
              <EmployerPaymentHistory />
            </ProtectedRoute>
          }
        />


      </Routes>
    </Router>
  );
}

export default App;
